import React from 'react'
import { ButtonOutline } from '../../../components'

const ImagePicker = () => {
  const fileInput = React.useRef()
  const [image, setImage] = React.useState(undefined)

  const handleChange = (e) => {
    console.log(e)
    setImage(URL.createObjectURL(e.target.files[0]))
  }

  return (
    <div>
      <input type="file" className="hide hidden" ref={fileInput} onChange={handleChange}/>
      <div
        className="border border-dashed mb-4 rounded cursor-pointer bg-center bg-no-repeat bg-cover"
        style={{borderColor: '#ddd', height: '170px', backgroundImage: image ? `url('${image}')` : '',}}
        onClick={() => fileInput.current.click()}
      />
      <p className="text-center text-gray-999 text-xs mb-6">JPG, GIF or PNG no larger than 1MB. Square images look the best!</p>
      <ButtonOutline onClick={() => fileInput.current.click()}>Choose File</ButtonOutline>
    </div>
  )
}

export { ImagePicker }